// 테넌트는 window.location.hostname 에서 동기(모듈 로드 시점)로 결정된다 —
// 어떤 모듈보다 먼저 확정되므로 모듈 스코프 소비(axios 인스턴스 등)에도 안전하다.
// key 는 백엔드 KNOWN_TENANTS(qesg|steel|hmc|kia|hyundai)와 동일한 hostname 라벨 계약을 따른다
// (df_backend_custom docs/multitenant-backend-contract.md §1.3 — X-Subdomain 값 = hostname 서브도메인 키).
// login: 로그인 대문 브랜딩 (custom 레포 prd/* 각 앱 layout-auth 하드코딩 값을 2026-09-02 추출·이관).
//   titleLines 는 데스크톱 h1 안에서 <br> 로 줄바꿈, mobileTitleLines 생략 시 titleLines 재사용.
//   heroTheme: 'blue' = supply 남색(#004389), 'teal' = custom 공통 청록(#00404E) — 패턴 정의는 layout-auth.vue.
// i18nOverrides: custom 앱 로컬 locales 의 로그인 문구 번역 이관 — loadLocaleMessages() 3단째 병합.
//   ko 는 키 자체가 한글 원문이라 항목 불필요(vue-i18n 키 폴백). custom 도 같은 방식이었다.
const TENANTS = {
    qesg: {
        key: 'qesg',
        legacyCustomEnv: 'supply',   // checkAppEnv() 과도기 값 — VUE_APP_CUSTOM_ENV 철거 후 이 값이 승계
        defaultRenderer: 'supply',
        login: {
            titleLines: ['지속가능한 공급망을 위한 ESG 실사'],
            subtitleLines: ['제3자 협력사 ESG 실사를 통해', '공급망의 지속가능성을 향상하세요'],
            heroTheme: 'blue',
        },
    },
    steel: {
        key: 'steel',
        legacyCustomEnv: 'ksteel',
        defaultRenderer: 'ksteel',
        // register: 평가신청 화면 테넌트 옵션 (custom prd/* Register 트리 이관, 2026-09-02).
        //   clients 첫 항목은 placeholder(value null). 없으면 드롭다운 미표시 + project_group 'SAQ' 고정(qesg 현행).
        register: {
            confirmGate: true,   // 신청 전 기업규모 재확인 모달 (steel InputConfirmModal)
            criteriaBox: true,   // 입력 기준 상시노출 박스 (팝오버 대신)
            clients: [
                {label: {ko: '원청사 선택', en: 'Select Main Contractor', ca: '选择总承包商'}, value: null},
                {label: {ko: '동국제강', en: 'Dongkuk Steel', ca: '东国制钢'}, value: 'dongkuk_steel_2026'},
                {label: {ko: '세아창원특수강', en: 'SEAH CSS', ca: '세아창원특수강'}, value: 'seah_css_2026'},
                {label: {ko: '세아베스틸', en: 'SEAH Besteel', ca: '세아베스틸'}, value: 'seah_besteel_2026'},
                {label: {ko: '세아특수강', en: 'SEAH Special Steel', ca: '세아특수강'}, value: 'seah_ss_2026'},
                {label: {ko: '세아항공방산소재', en: 'SEAH A&D Materials', ca: '세아항공방산소재'}, value: 'seah_ad_2026'},
                {label: {ko: 'KG스틸', en: 'KG Steel', ca: 'KG Steel'}, value: 'kg_steel_2026'},
            ],
        },
        login: {
            titleLines: ['한국철강협회', '철강 공급망 ESG 실사'],
            subtitleLines: ['철강협회 공동 ESG 실사에 참여하여', '지속가능 경영을 실현하세요.'],
            heroTheme: 'teal',
        },
        i18nOverrides: {
            en: {
                '한국철강협회': 'Korea Iron & Steel Association',
                '철강 공급망 ESG 실사': 'ESG Assessment of the Steel Supply Chain',
                '철강협회 공동 ESG 실사에 참여하여': 'Participate in the Joint ESG Assessment of the Steel Association',
                '지속가능 경영을 실현하세요.': 'to achieve sustainable management.',
            },
            ca: {
                '한국철강협회': '韩国钢铁协会',
                '철강 공급망 ESG 실사': '钢铁供应链ESG评估',
                '철강협회 공동 ESG 실사에 참여하여': '参与钢铁协会联合ESG评估',
                '지속가능 경영을 실현하세요.': '实现可持续经营。',
            },
        },
    },
    'hmc-theme': {
        key: 'hmc-theme',
        legacyCustomEnv: 'hmc-theme', // custom prd-theme 실값 확인 (HMCManual is_theme_env 등이 이 문자열 비교)
        defaultRenderer: 'hmc_theme',
        register: {
            clients: [
                {label: '현대자동차 • 기아', value: 'hmc_theme_2026'},
                {label: '개별 평가', value: 'individual_assessment_2026'},
            ],
            // 구세대 모놀리스 기능 공용화 — 서브도메인별 On/Off (custom 라이브와 동등성 유지용 On)
            newSiteProjectCode: 'hd_new_26',   // ?nwas 신규 사업장 직접 등록
            priorityAssessment: true,          // priority_vendor_code 대체평가 안내
        },
        login: {
            titleLines: ['2026 현대자동차·기아 공급망 ESG 테마평가'],
            subtitleLines: ['협력사 ESG 조사 · 평가를 통해', '지속가능성을 향상하세요'],
            heroTheme: 'teal',
        },
        i18nOverrides: {
            en: {'2026 현대자동차·기아 공급망 ESG 테마평가': '2026 Hyundai Motor Company & Kia Supply Chain ESG Theme Assessment'},
            ca: {'2026 현대자동차·기아 공급망 ESG 테마평가': '2026年HMC供应链ESG主题评估'},
        },
    },
    hmc: {
        key: 'hmc',
        legacyCustomEnv: 'hmc',
        defaultRenderer: 'hmc',
        // label 이 문자열이면 $t() i18n 키로 처리 (모놀리스 방식 승계), 객체면 {ko,en,ca}
        register: {
            clients: [
                {label: '현대자동차 • 기아', value: 'hyundai_motors_and_kia_2025'},
                {label: '개별 평가', value: 'individual_assessment_2025'},
            ],
        },
        login: {
            titleLines: ['2025년 현대자동차 • 기아', 'ESG 협력사 평가'],
            mobileTitleLines: ['2025년 현대 • 기아차', 'ESG 협력사 평가'],
            subtitleLines: ['협력사 ESG 조사 · 평가를 통해', '지속가능성을 향상하세요'],
            heroTheme: 'teal',
        },
        i18nOverrides: {
            en: {
                '2025년 현대자동차 • 기아': '2025 Hyundai Motor Company • Kia',
                'ESG 협력사 평가': 'Supplier ESG Evaluation',
            },
            // ca 는 custom 도 타이틀 1키만 보유 — 나머지는 한글 폴백이 원래 동작
            ca: {'2025년 현대자동차 • 기아': '2025年现代汽车•起亚'},
        },
    },
    kia: {
        key: 'kia',
        legacyCustomEnv: 'kia',
        defaultRenderer: 'kia',
        register: {
            clients: [{label: '기아', value: 'kia'}],
        },
        login: {
            titleLines: ['2025년 기아 글로벌 사업장 ESG 평가'],
            subtitleLines: ['ESG 조사 · 평가를 통해', '지속가능성을 향상하세요'],
            heroTheme: 'teal',
        },
        i18nOverrides: {
            en: {'2025년 기아 글로벌 사업장 ESG 평가': '2025 Kia Global Operations ESG Assessment'},
            ca: {'2025년 기아 글로벌 사업장 ESG 평가': '2025年起亚全球业务ESG评估'},
        },
    },
    hyundai: {
        key: 'hyundai',
        legacyCustomEnv: 'hyundai',
        defaultRenderer: 'hyundai',
        // hyundai.tierzero.kr 현행 서빙 앱은 hyundai-v2 — 대문/평가신청도 v2 를 따른다
        register: {
            clients: [
                {label: {ko: '현대차 사업장 평가', en: 'Hyundai Motor Business Site Assessment', ca: '现代汽车事业场评价'}, value: 'hyundai_26'},
            ],
            newSiteProjectCode: 'hd_new_26',
            priorityAssessment: true,
        },
        login: {
            titleLines: ['2026년 현대차', '사업장 ESG 평가'],
            mobileTitleLines: ['2026년 현대차 사업장 ESG 평가'],
            subtitleLines: ['ESG 평가에 참여함으로써 사업장의 지속가능한 발전을 도모하세요.'],
            heroTheme: 'teal',
        },
        i18nOverrides: {
            en: {
                '2026년 현대차 사업장 ESG 평가': '2026 Hyundai Motor Business Site ESG Assessment',
                '2026년 현대차': '2026 Hyundai Motor',
                '사업장 ESG 평가': 'Business Site ESG Evaluation',
                'ESG 평가에 참여함으로써 사업장의 지속가능한 발전을 도모하세요.': 'By participating in the ESG assessment, contribute to the sustainable development of the business site.',
            },
            ca: {
                '2026년 현대차 사업장 ESG 평가': '2026现代汽车法人ESG评价',
                '2026년 현대차': '2026现代汽车',
                '사업장 ESG 평가': '法人ESG评价',
                'ESG 평가에 참여함으로써 사업장의 지속가능한 발전을 도모하세요.': '通过参与ESG评估，为事业场所的可持续发展作出贡献。',
            },
        },
    },
    // hyundai-2025.tierzero.kr — 2025 현대차 사업장 평가(구 apps/hyundai 동결 빌드). 유저 결정(2026-09-03)으로
    // 잔재 유지 대신 단일 빌드에 온보딩 → custom CF 완전 철거 가능. 캠페인은 종료 상태라 평가신청 확장 기능은 Off.
    'hyundai-2025': {
        key: 'hyundai-2025',
        legacyCustomEnv: 'hyundai',
        defaultRenderer: 'hyundai',
        register: {
            clients: [{label: '현대차', value: 'hyundai'}],
        },
        login: {
            // custom apps/hyundai 원문: `2025년 현대차 사업장 <br> ESG 평가` (2026 hyundai 와 분할 위치가 다름)
            titleLines: ['2025년 현대차 사업장', 'ESG 평가'],
            mobileTitleLines: ['2025년 현대차 사업장 ESG 평가'],
            subtitleLines: ['ESG 평가에 참여함으로써 사업장의 지속가능한 발전을 도모하세요.'],
            heroTheme: 'teal',
        },
        i18nOverrides: {
            en: {
                '2025년 현대차 사업장 ESG 평가': '2025 Hyundai Motor Business Site ESG Assessment',
                '2025년 현대차 사업장': '2025 Hyundai Motor Business Site',
                'ESG 평가': 'ESG Evaluation',
                'ESG 평가에 참여함으로써 사업장의 지속가능한 발전을 도모하세요.': 'By participating in the ESG assessment, contribute to the sustainable development of the business site.',
            },
            ca: {
                '2025년 현대차 사업장 ESG 평가': '2025现代汽车法人ESG评价',
                '2025년 현대차 사업장': '2025现代汽车法人',
                'ESG 평가': 'ESG评价',
                'ESG 평가에 참여함으로써 사업장의 지속가능한 발전을 도모하세요.': '通过参与ESG评估，为事业场所的可持续发展作出贡献。',
            },
        },
    },
};

// 서버(brands DB) 런타임 register 설정을 코드 기본값 위에 병합.
// 서버가 단일 소스이고 TENANTS 의 register 는 "서버 응답 전/실패 시 폴백 기본값"이다 —
// On/Off 변경은 DB 만 바꾸면 되고 배포가 필요 없다 (배포 순서 무관 안전).
// remote 키는 백엔드 snake_case 계약 (GET /register/tenant-config).
const REMOTE_REGISTER_KEYS = {
    new_site_project_code: 'newSiteProjectCode',
    priority_assessment: 'priorityAssessment',
    confirm_gate: 'confirmGate',
    criteria_box: 'criteriaBox',
    clients: 'clients',
};

function mergeTenantRegister(codeRegister, remote) {
    if (!remote || typeof remote !== 'object') return codeRegister || null;
    const merged = {...(codeRegister || {})};
    for (const snake of Object.keys(REMOTE_REGISTER_KEYS)) {
        if (remote[snake] !== undefined) merged[REMOTE_REGISTER_KEYS[snake]] = remote[snake];
    }
    return Object.keys(merged).length ? merged : null;
}

function resolveTenantKey(hostname) {
    if (!hostname) return null;
    const label = hostname.split('.')[0].toLowerCase();
    // 로컬 개발 폴백 — 미등록 호스트 fail-closed 원칙의 유일한 예외
    if (label === 'localhost' || label === '127' || label === '0') return 'qesg';
    // 미등록 호스트는 null — prod fail-closed 처리는 소비자(부트스트랩)가 판단한다
    return Object.prototype.hasOwnProperty.call(TENANTS, label) ? label : null;
}

const tenantKey = typeof window !== 'undefined' ? resolveTenantKey(window.location.hostname) : null;
const tenant = tenantKey ? TENANTS[tenantKey] : null;

export { TENANTS, resolveTenantKey, tenantKey, tenant, mergeTenantRegister };
